var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { BaseModal } from '../modals';
let ModalOverlay = class ModalOverlay extends React.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "onCloseClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (type) => {
                const { appStore } = this.props;
                appStore.hideModal(type);
            }
        });
        Object.defineProperty(this, "renderModals", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { appStore } = this.props;
                const { modals } = appStore;
                const modalsElements = [];
                modals.forEach((value, key) => {
                    const { showCloseButton, isCheckoutViewModal, title, className, overlayClassName, titleClassName, contentClassName, closeButtonClassName, isDynamicTitle, ...props } = value;
                    const baseModalProps = {
                        showCloseButton,
                        isCheckoutViewModal,
                        title,
                        className,
                        titleClassName,
                        contentClassName,
                        overlayClassName,
                        isDynamicTitle,
                        closeButtonClassName
                    };
                    modalsElements.push(React.createElement(BaseModal, { key: key, type: key, props: props, ...baseModalProps, onClose: this.onCloseClick }));
                });
                return modalsElements;
            }
        });
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { appStore: { hideAllModals, modals }, location } = this.props;
        if (location !== prevProps.location && modals.size > 0) {
            hideAllModals();
        }
    }
    render() {
        return (React.createElement("div", { className: '' }, this.renderModals()));
    }
};
ModalOverlay = __decorate([
    inject('appStore'),
    observer
], ModalOverlay);
export default ModalOverlay;
